import { render, staticRenderFns } from "./BuildingAddStaffModal.vue?vue&type=template&id=79dfe05c&"
import script from "./BuildingAddStaffModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingAddStaffModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79dfe05c')) {
      api.createRecord('79dfe05c', component.options)
    } else {
      api.reload('79dfe05c', component.options)
    }
    module.hot.accept("./BuildingAddStaffModal.vue?vue&type=template&id=79dfe05c&", function () {
      api.rerender('79dfe05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingAddStaffModal.vue"
export default component.exports